import { FC } from 'react'
import cx from 'classnames'

import AdsCard, { AdsCardProps } from '../AdsCard'

import * as SC from './styled'

export type AdsGridProps = {
  className?: string
  items: Array<AdsCardProps>
}

const AdsGrid: FC<AdsGridProps> = ({ className, items }) => {
  return (
    <SC.AdsGrid className={cx('AdsGrid', className)}>
      {items.map((item, index) => (
        <SC.AdsGridItem key={index}>
          <AdsCard {...item} />
        </SC.AdsGridItem>
      ))}
    </SC.AdsGrid>
  )
}

export default AdsGrid
